import {
    addToChainAfter,
    ApiHandlerDiscreteParameter,
} from "@insite/client-framework/HandlerCreator";
import { AddAccountApiParameter } from "@insite/client-framework/Services/AccountService";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { AddAccount, chain } from "@insite/client-framework/Store/Data/Accounts/Handlers/AddAccount";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";
import { userCreated } from "@WhiteCap/Common/Utillities/CustomTracking";

export interface AddAccountParameter {
    userName: string;
    email: string;
    password: string;
    isSubscribed: boolean;
    onSuccess?: () => void;
    onError?: (error: string) => void;
}

type HandlerType = ApiHandlerDiscreteParameter<
    AddAccountParameter,
    AddAccountApiParameter,
    ServiceResult<AccountModel>
>;


export const AddAccountSendDataLayer: HandlerType = props => {
    if (props.apiResult.successful) {
        userCreated({
            event: "user_created",
            account_type: "Personal",
            user_id: props?.apiResult?.result?.userName ?? props?.parameter?.email
        })
    }
};

addToChainAfter(chain, AddAccount, AddAccountSendDataLayer);